module.exports = __webpack_public_path__ + "img/bg.c9be5d04.svg";